export default __webpack_public_path__ + "static/media/006-creative work.c2d88653.svg";